module.exports = __webpack_public_path__ + "static/assets/2ccd6c3213ee8bb9513ba16f8851e6f0.png";